import { Icon } from "semantic-ui-react";
import { getCount } from "./helper";
import { getPreposition } from "./helper";
import { ConfirmBoxType } from "../reducer/type";
import { safeToLowerCase } from "../../../shared-functions/string";

type TitleProps = Pick<ConfirmBoxType, "entity" | "operation" | "resources">;

const Title = ({ entity, operation, resources }: TitleProps) => {
  const count = getCount(resources);
  const isSingular = count === 1;

  const article =
    isSingular &&
    ["a", "e", "i", "o", "u"].includes(safeToLowerCase(entity?.[0] || ""))
      ? "an"
      : "a";
  const formattedCount = isSingular ? article : count;

  return (
    <p className="padding-top-10 padding-right-20 padding-bottom-00 padding-left-20 color-red font-XL">
      <Icon name="warning circle" className="margin-right" />
      About to {operation}
      {getPreposition(operation)} {formattedCount} {entity}
      {count > 1 && "s"}.
    </p>
  );
};

export default Title;
